import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { LoopInterface } from '../../+models';
import { LoopsActions, LoopsActionTypes } from './loop.actions';

export const NAME = 'loops';

export interface State extends EntityState<LoopInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<LoopInterface> = createEntityAdapter<LoopInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: LoopsActions): State {
  switch (action.type) {
    case LoopsActionTypes.AddLoop: {
      return adapter.addOne(action.payload.loop, state);
    }

    case LoopsActionTypes.UpsertLoop: {
      return adapter.upsertOne(action.payload.loop, state);
    }

    case LoopsActionTypes.AddLoops: {
      return adapter.addMany(action.payload.loops, state);
    }

    case LoopsActionTypes.UpsertLoops: {
      return adapter.upsertMany(action.payload.loops, state);
    }

    case LoopsActionTypes.UpdateLoop: {
      return adapter.updateOne(action.payload.loop, state);
    }

    case LoopsActionTypes.UpdateLoops: {
      return adapter.updateMany(action.payload.loops, state);
    }

    case LoopsActionTypes.DeleteLoop: {
      return adapter.removeOne(action.payload.id, state);
    }

    case LoopsActionTypes.DeleteLoops: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case LoopsActionTypes.LoopsLoaded: {
      return adapter.setAll(action.payload.loops, { ...state, loaded: true });
    }

    case LoopsActionTypes.LoopsLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    case LoopsActionTypes.ClearLoops: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
